import { useEffect, useState } from 'react';
import { fetchPingAuthFlowState } from './pingAuthFlowGateway';
import { AuthFlowState, blankAuthFlowState } from '../../../domain/AuthFlowState';

export interface AuthFlowStateResult {
    loading: boolean;
    error: boolean;
    authFlowState: AuthFlowState;
    redirectUrl?: string;
}

export const usePingAuthFlow = (flowId?: string): AuthFlowStateResult => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [authFlowState, setAuthFlowState] = useState<AuthFlowState>(blankAuthFlowState);
    const [redirectUrl, setRedirectUrl] = useState<string | undefined>(undefined);

    useEffect((): void => {
        const fetch = async (): Promise<void> => {
            try {
                setAuthFlowState(await fetchPingAuthFlowState(flowId));
            } catch (e: any) {
                if (e?.response?.data?.redirectUrl) {
                    setRedirectUrl(e?.response?.data?.redirectUrl);
                }
                setError(true);
            }
            setLoading(false);
        };
        // noinspection JSIgnoredPromiseFromCall
        fetch();
    }, [flowId]);

    return { loading, error, authFlowState, redirectUrl };
};
